
import $ from 'jquery';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { Board, Card, CardAttribute, CardAttributeDefinition } from '../../../../backend/backendapi';
import { KanbanState } from '../../../kanban.model';
import { SystemAttributes } from './attributes.model';
import { WindowType } from '../../../../../util';
import AttributeEditor from './attribute/AttributeEditor';
import TabButton from '../../../../util/TabButton';
import ActivityAttributeEditor from './systemattribute/ActivityAttributeEditor';
import CellAttributeEditor from './systemattribute/CellAttributeEditor';
import Spinner from '../../../../util/Spinner';

declare var window: WindowType;

@Component({
  components: {
    ActivityAttributeEditor,
    AttributeEditor,
    CellAttributeEditor,
    Spinner,
    TabButton,
  },
})
export default class AttributesEditModal extends Vue {
  @Prop({ required: true })
  readonly state!: KanbanState;
  @Prop({ required: true })
  readonly board!: Board;
  @Prop({ required: true })
  readonly card!: Card;
  @Prop({ default: false })
  readonly saving!: boolean;

  attributes: CardAttribute[] = [];
  systemAttributes = new SystemAttributes();
  tab: 'system' | 'custom' = 'custom';

  get canActivity(): boolean {
    return window.application.permissions.activity.activity;
  }

  get definitions(): CardAttributeDefinition[] {
    return this.board.attributeDefinitions ?? [];
  }

  public open(args?: { tab: 'system' | 'custom' }): void {
    $(this.$refs.modal!).modal('show');
    if (args?.tab) {
      this.tab = args.tab;
    }

    this.attributes.splice(0);
    this.attributes.push(...(this.card.attributes ?? []).map(e => new CardAttribute(e)));

    this.systemAttributes = new SystemAttributes();
    this.systemAttributes.cellId = this.card.cellId;
    this.systemAttributes.activityId = this.card.activityId || (null as any); //activityid can also be 0
  }

  public dismiss(): void {
    $(this.$refs.modal!).modal('hide');
  }

  getAttribute(definition: CardAttributeDefinition): CardAttribute {
    let attr = this.attributes.find(e => e.definitionId === definition.id);
    if (!attr) {
      attr = new CardAttribute({ id: 0, cardId: this.card.id!, definitionId: definition.id, value: '' });
      this.attributes.push(attr);
    }
    return attr;
  }

  async save(): Promise<void> {
    this.$emit('save', this.attributes, this.systemAttributes);
  }
}
